// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__1f6Xt","tabs":"LayoutWrapperSideNav_tabs__2wmMD","tab":"LayoutWrapperSideNav_tab__kXVxD"};